/* eslint-disable react/jsx-props-no-spreading ,react/destructuring-assignment,  @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react'
import { OptionProps } from 'react-select'
import { SelectItems } from '../../../types/select'
import { Selection } from './styled-components'

interface SelectProps {
  options: readonly OptionProps[]
  onChange?: (option: SelectItems) => void
  value?: SelectItems
}

function Select({ options, onChange, value }: SelectProps): ReactElement {
  return (
    <Selection
      value={value}
      options={options}
      classNamePrefix="Select"
      placeholder=" إختر إجابة..."
      onChange={onChange as any}
      isSearchable={false}
      isRtl
    />
  )
}

export default Select
